import type {Content, ImageField, RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import {DefaultTiles3WithHoverDescription} from './DefaultTiles3WithHoverDescription'

export type Tiles3WithHoverDescriptionProps = SliceComponentProps<Content.Tiles3WithHoverDescriptionSlice>

const Tiles3WithHoverDescription = ({slice}: Tiles3WithHoverDescriptionProps): JSX.Element | null => {
  switch (slice.variation) {
    case 'default': {
      const p = slice.primary

      const tiles = slice.items
        .filter(
          (item) =>
            isFilled.keyText(item.tile_heading) || isFilled.richText(item.tile_copy) || isFilled.image(item.tile_image),
        )
        .map((item) => ({
          heading: isFilled.keyText(item.tile_heading) ? item.tile_heading : '',
          copy: isFilled.richText(item.tile_copy) ? item.tile_copy : ([] as RichTextField),
          secondaryCopy: isFilled.richText(item.tile_secondary_copy) ? item.tile_secondary_copy : ([] as RichTextField),
          image: isFilled.image(item.tile_image) ? item.tile_image : ({} as ImageField),
        }))

      return (
        <DefaultTiles3WithHoverDescription
          sliceType={slice.slice_type}
          sliceVariation={slice.variation}
          paddingTop={p.padding_top}
          paddingBottom={p.padding_bottom}
          background={p.background}
          tileNumbering={p.tile_numbering}
          eyebrow={isFilled.keyText(p.eyebrow) ? p.eyebrow : ''}
          heading={isFilled.richText(p.heading) ? p.heading : []}
          description={Array.isArray(p.description) && isFilled.richText(p.description) ? p.description : []}
          tiles={tiles}
        />
      )
    }

    default:
      return null
  }
}

export default Tiles3WithHoverDescription
